import React, { cloneElement, useState } from "react";

export const createPlaywrightForm = () => (WrappedComponent) => {
  const PlaywrightForm = (props) => {
    const [values, setValues] = useState({});
    const form = {
      getFieldDecorator: (name, options = {}) => (field) => {
        const value = values[name] === undefined ? options.initialValue : values[name];
        const onChange = (...args) => {
          const event = args[0];
          setValues((current) => ({ ...current, [name]: event?.target?.value ?? event }));
          field.props.onChange?.(...args);
        };
        return cloneElement(field, { id: field.props.id || name, value, onChange });
      },
      validateFields: (callback) => callback(null, values),
    };
    return <WrappedComponent {...props} form={form} />;
  };
  return PlaywrightForm;
};
